import { cn } from '~/lib/utils';
import { formatSeconds } from '~/utils/time';

interface GameHighScoreProps {
  moves: number;
  movesLabel?: string;
  seconds?: number;
  score: string | number;
}

export function GameHighScore({ moves, movesLabel = 'Moves', seconds, score }: GameHighScoreProps) {
  return (
    <div className='body-sm border-border mt-5 overflow-hidden rounded-lg border text-center'>
      <h3 className='bg-teal font-greycliff-bold py-1 uppercase text-white'>Your Best Score</h3>
      <dl className={cn('grid py-2', !seconds && 'grid-cols-2', !!seconds && 'grid-cols-3')}>
        <dt className='font-greycliff-bold text-muted-foreground row-start-1'>{movesLabel}</dt>
        <dd className='text-muted-foreground row-start-2'>{moves}</dd>
        {seconds && (
          <>
            <dt className='font-greycliff-bold text-muted-foreground row-start-1'>Time</dt>
            <dd className='text-muted-foreground row-start-2'>{formatSeconds(seconds)}</dd>
          </>
        )}
        <dt className='font-greycliff-bold text-muted-foreground row-start-1'>Score</dt>
        <dd className='text-muted-foreground row-start-2'>{score}</dd>
      </dl>
    </div>
  );
}
